import { render, staticRenderFns } from "./GroupDisplay.component.vue?vue&type=template&id=16ee8d7b&"
import script from "./GroupDisplay.component.vue?vue&type=script&lang=ts&"
export * from "./GroupDisplay.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports